import React,{Fragment,useEffect,useState} from 'react'
import {auth} from '../firebase'
import {Link,useHistory} from 'react-router-dom'
function Menu() {
    const historial = useHistory();
    const[usuario,setUsuario]=useState(null)
    useEffect(() => {
        auth.onAuthStateChanged((user)=>{
            if(user){
                setUsuario(user.email)
            }
        })    
    }, [])

    const cerrarSession=()=>{
        auth.signOut();
        setUsuario(null)
        historial.push("/")
    }
    return (
        <Fragment>
            
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                <div className="container-fluid">
                    <Link className="text-white navbar-brand" to="/">Login Reactjs</Link>
                    <div className="d-flex">
                    
                       
                            <ul className="row">
                                
                                <li className="nav-item col-md-3">
                                {
                                    usuario?(
                                        <span></span>
                                        ):(<Link className="text-white nav-link" to="/login">Login</Link>)
                                }
                                    
                                </li>
                                <li className="nav-item col-md-4">
                                {
                                    usuario?(
                                        <Link className="text-white nav-link" to="/admin">Admin</Link>
                                        ):(<span></span>)
                                }
                                    
                                </li>
                                {
                                    usuario?(
                                        <li className="nav-item col-md-4 d-block float-end">
                                            <button 
                                                onClick={cerrarSession}
                                                className="btn btn-danger fs-6 btn-outline-danger btn-lg text-white"
                                                >
                                                    Salir
                                            </button>
                                        </li>
                                        ):(<span></span>)
                                }
                              
                            </ul>
                        
                    </div>
                    
                
                </div>
            </nav>
        </Fragment>
    )
}

export default Menu